// Generated by ReScript, PLEASE EDIT WITH CARE


var sdkDomainUrl = sdkUrl + publicPath;

var apiEndPoint = {
  contents: undefined
};

function setApiEndPoint(str) {
  apiEndPoint.contents = str;
}

function getApiEndPoint(publishableKeyOpt, isConfirmCallOpt) {
  var publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  var isConfirmCall = isConfirmCallOpt !== undefined ? isConfirmCallOpt : false;
  publishableKey.startsWith("pk_snd_");
  var str = apiEndPoint.contents;
  if (str !== undefined) {
    return str;
  } else if (isConfirmCall) {
    return confirmEndPoint;
  } else {
    return backendEndPoint;
  }
}

function addCustomPodHeader(arr, customPodUri) {
  if (customPodUri !== undefined && customPodUri !== "") {
    arr.push([
          "x-feature",
          customPodUri
        ]);
  }
  return Object.fromEntries(arr);
}

var switchToInteg = false;

var isLocal = false;

export {
  switchToInteg ,
  isLocal ,
  sdkDomainUrl ,
  apiEndPoint ,
  setApiEndPoint ,
  getApiEndPoint ,
  addCustomPodHeader ,
}
/* sdkDomainUrl Not a pure module */
